export * from './render-svg';
export { default as svgMapping } from './svg-mapping.json';
